import * as AppPics from 'assets/images';

function Html() {
  return (
    <div className="mainWraper coursetabsection p-5">
      <div className="notificationouter">
        <div className="notificationmaintitle">Latest Notifications</div>
        <div className="notificationmaincontent">
          <div className="notificationdetail">
            <div className="whitebg"></div>
            <div className="notificationleftimg green">
              <img src={AppPics.TabGridSvg} alt="" />
            </div>
            <div className="notificationrightcontent">
              <div className="notificationrightcontenttop">
                <span className="contenttopmessage">New Message</span>
                <span className="contenttoptime">1 hr ago</span>
              </div>
              <div className="notificationrightcontentbottom">
                Let's meet at starbucks today, are you free?
              </div>
            </div>
          </div>
          <div className="notificationdetail">
            <div className="whitebg"></div>
            <div className="notificationleftimg red">
              <img src={AppPics.TabGridSvg} alt="" />
            </div>
            <div className="notificationrightcontent">
              <div className="notificationrightcontenttop">
                <span className="contenttopmessage">New Message</span>
                <span className="contenttoptime">1 hr ago</span>
              </div>
              <div className="notificationrightcontentbottom">
                Let's meet at starbucks today, are you free?
              </div>
            </div>
          </div>
          <div className="notificationdetail">
            <div className="whitebg"></div>
            <div className="notificationleftimg orange">
              <img src={AppPics.TabGridSvg} alt="" />
            </div>
            <div className="notificationrightcontent">
              <div className="notificationrightcontenttop">
                <span className="contenttopmessage">New Message</span>
                <span className="contenttoptime">1 hr ago</span>
              </div>
              <div className="notificationrightcontentbottom">
                Let's meet at starbucks today, are you free?
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="notificationouter ticketsection">
        <div className="notificationmaintitle">
          <span className="boldtitle">Latest tickets</span>
          <span className="rightalign">
            <img src={AppPics.TabGridSvg} alt="" />
          </span>
        </div>
        <div className="notificationmaincontent">
          <div className="notificationdetail">
            <div className="notificationrightcontent">
              <div className="notificationrightcontenttop boldtitle">
                Ticket
                <span className="ticketnumber">#4231852</span>
              </div>
              <div className="notificationrightcontentbottom">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium{' '}
              </div>
            </div>
          </div>
          <div className="notificationdetail">
            <div className="notificationrightcontent">
              <div className="notificationrightcontenttop boldtitle">
                Ticket
                <span className="ticketnumber">#4231852</span>
              </div>
              <div className="notificationrightcontentbottom">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium{' '}
              </div>
            </div>
          </div>
          <div className="notificationdetail">
            <div className="notificationrightcontent">
              <div className="notificationrightcontenttop boldtitle">
                Ticket
                <span className="ticketnumber">#4231852</span>
              </div>
              <div className="notificationrightcontentbottom">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium{' '}
              </div>
            </div>
          </div>
          <div className="expanddownarrow">
            <img src={AppPics.TabGridSvg} alt="" />
          </div>
        </div>
      </div>

      <div className="notificationouter ticketsection design2">
        <div className="notificationmaintitle">
          <span className="">Notifications</span>
          <span className="rightalign">
            <img src={AppPics.TabGridSvg} alt="" />
          </span>
        </div>
        <div className="notificationmaincontent">
          <div className="notificationdetail">
            <div className="notificationleftimg">
              <img src={AppPics.TabGridSvg} alt="" />
            </div>
            <div className="notificationrightcontent">
              <div className="notificationrightcontenttop">
                <span className="contenttopmessage">
                  <span className="username">John Doe</span> sent you an invoice.
                </span>
              </div>
              <div className="notificationrightcontentbottom">4 min ago</div>
            </div>
          </div>
          <div className="notificationdetail">
            <div className="notificationleftimg">
              <img src={AppPics.TabGridSvg} alt="" />
            </div>
            <div className="notificationrightcontent">
              <div className="notificationrightcontenttop">
                <span className="contenttopmessage">
                  <span className="username">John Doe</span> sent you an invoice.
                </span>
              </div>
              <div className="notificationrightcontentbottom">4 min ago</div>
            </div>
          </div>
          <div className="notificationdetail">
            <div className="notificationleftimg">
              <img src={AppPics.TabGridSvg} alt="" />
            </div>
            <div className="notificationrightcontent">
              <div className="notificationrightcontenttop">
                <span className="contenttopmessage">
                  <span className="username">John Doe</span> sent you an invoice.
                </span>
              </div>
              <div className="notificationrightcontentbottom">4 min ago</div>
            </div>
          </div>
          <div className="expanddownarrow viewall">View all notifications</div>
        </div>
      </div>
    </div>
  );
}

export default Html;
